<div class="frac-home-purchase-orders">
  <sa-lmo-frac-home-card localStorageKey="home__purchase-order" [isLoading]="!(meshesWithFcpos$ | async)">
    <header class="flex justify-between my-1 py-2">
      <div class="flex items-center">
        <img src="/assets/icons/purchase-orders-v2.svg" alt="Purchase Orders" />
        <span class="text-xl font-medium">Purchase Orders</span>
      </div>
      <div>
        <a
          *saAllowedAccountRoles="['admin', 'dispatcher']"
          [routerLink]="['./', 'lmo_frac_home_modal', 'purchase_orders']"
          class="button-add"
          >Add</a
        >
      </div>
    </header>
    <main *ngIf="meshesWithFcpos$ | async as meshesWithFcpos; else noPOs">
      <ng-container *ngFor="let meshWithFcpos of meshesWithFcpos; trackBy: trackById">
        <div class="group-header">
          <span>{{ meshWithFcpos.type }} Mesh</span>
          <span class="t-o-number"
            >{{ meshWithFcpos.orderedToday || 0 | approxBigNumber }} /
            {{ meshWithFcpos.maximumDailyAllocation | approxBigNumber }} lbs
          </span>
        </div>
        <div class="mesh-group">
          <a
            class="purchase-order"
            *ngFor="let fcpo of meshWithFcpos.fcpos; trackBy: trackById; let i = index"
            [routerLink]="userIsAdmin ? ['./', 'lmo_frac_home_modal', 'purchase_orders', 'manage', fcpo.id] : []"
            saAutomatedSelector="fcpo_list__row"
          >
            <div class="rank">{{ i + 1 }}</div>
            <div class="content">
              <div class="fcpo-header">
                <ng-container *ngIf="fcpo.downReport || fcpo.isClosed; else loaderUp">
                  <span
                    [ngClass]="{ 'warn-orange': fcpo.isClosed, warn: fcpo.downReport, disabled: showPopover }"
                    class="mine-name warn"
                    [mdePopoverTriggerFor]="siteWarning"
                    mdePopoverTriggerOn="hover"
                    [mdePopoverOverlapTrigger]="false"
                    saAutomatedSelector="fcpo_list__po_mine_name"
                    >{{ fcpo.purchaseOrder.mineName }} ({{ fcpo.billableMileage }} miles)
                    <ng-container *ngIf="fcpo.downReport; else isClosedIcon">
                      <mat-icon class="warning">warning</mat-icon>
                    </ng-container>
                    <ng-template #isClosedIcon>
                      <mat-icon class="warn-orange">access_time</mat-icon>
                    </ng-template>
                  </span>
                  <mde-popover #siteWarning="mdePopover" [ngClass]="{ disabled: showPopover }">
                    <ng-container *ngIf="fcpo.downReport; else isClosed">
                      <div class="down-report-message">
                        <div class="header">
                          Loader Reported Down at {{ fcpo.downReport.createdTimestamp | date: 'short' }}
                        </div>
                        <div
                          class="sub-header"
                          *ngIf="fcpo.downReport.description && fcpo.downReport.description.length > 0"
                        >
                          {{ fcpo.downReport.reportedUser }} reported {{ fcpo.downReport.site?.name }} down for
                          {{ fcpo.downReport.eta | minutesToHuman }}: "{{ fcpo.downReport.description }}".
                        </div>

                        <div
                          class="sub-header"
                          *ngIf="!fcpo.downReport.description || fcpo.downReport.description.length === 0"
                        >
                          {{ fcpo.downReport.reportedUser }} reported {{ fcpo.downReport.site?.name }} down for
                          {{ fcpo.downReport.eta | minutesToHuman }}
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #isClosed>
                      <div class="is-closed-message">
                        <div class="header">
                          Scheduled Non-Operational Hours
                        </div>
                      </div>
                    </ng-template>
                  </mde-popover>
                </ng-container>
                <ng-template #loaderUp>
                  <span
                    class="mine-name"
                    saAutomatedSelector="fcpo_list__po_mine_name"
                    [saAllowedAccountRolesEnabledFor]="['admin', 'dispatcher']"
                    ><mat-icon
                      matTooltip="PO paused by {{ fcpo.purchaseOrder.pausedBy }} at {{
                        fcpo.purchaseOrder.pausedTimestamp | standardDate
                      }}: {{ fcpo.purchaseOrder.pausedDescription | dashIfNothing }}"
                      class="mr-1 text-red-501"
                      *ngIf="fcpo.purchaseOrder.pausedTimestamp !== null"
                      >pause</mat-icon
                    >
                    {{ fcpo.purchaseOrder.mineName }} ({{ fcpo.billableMileage }} miles)
                    <div class="font-bold" *ngIf="frac.percentBasedAutoOrdering">
                      &nbsp;{{
                        (((fcpo.percentBasedAutoOrderingAllocation || 0) /
                          (fcpo.percentBasedAutoOrderingTotalAllocation || 1)) *
                          100 | number) + '%'
                      }}
                    </div>
                    <mat-icon
                      class="ml-1 text-red-501"
                      *ngIf="fcpo.defaultLoadWeight"
                      matTooltip="Default Load Weight Manually Set at {{ fcpo.defaultLoadWeight | number }}"
                      >fitness_center</mat-icon
                    >
                  </span>
                </ng-template>
                <div class="allocation t-o-number" [saAllowedAccountRolesEnabledFor]="['admin', 'dispatcher']">
                  <span class="ordered" [class.warn]="dailyOver(fcpo.purchaseOrder)">{{
                    fcpo.purchaseOrder.orderedToday || 0 | approxBigNumber
                  }}</span>
                  / {{ fcpo.purchaseOrder.maximumDailyAllocation || 0 | approxBigNumber }} lbs (Daily)
                </div>
              </div>
              <div class="fcpo-body" [saAllowedAccountRolesEnabledFor]="['admin', 'dispatcher']">
                <div class="fcpo-name">
                  <span
                    class="po-name"
                    [class.warning]="isMaxedOut(fcpo.purchaseOrder)"
                    [class.maxed-out]="isMaxedOut(fcpo.purchaseOrder)"
                    >{{ fcpo.purchaseOrder.name }}</span
                  >
                  <div class="allocation t-o-number">
                    <span class="ordered" [class.warn]="totalOver(fcpo.purchaseOrder)">
                      {{ fcpo.purchaseOrder.totalAllocationUsed || 0 | approxBigNumber }}</span
                    >
                    / {{ fcpo.purchaseOrder.allocation || 0 | approxBigNumber }} lbs (Total)
                  </div>
                </div>
                <div class="flex justify-between">
                  <div>
                    <span class="wait-time" *ngIf="fcpo.mineWaitTime === 0">In & Out Time: Not Available </span>
                    <span class="wait-time" *ngIf="fcpo.mineWaitTime !== 0" [class.warning]="fcpo.mineWaitTime >= 60">
                      {{ fcpo.mineWaitTime | minutesToHuman }} est. In & Out Time
                    </span>
                  </div>
                  <div>
                    {{
                      (fcpo.purchaseOrder.todayTotalOrderCountPercentage
                        ? fcpo.purchaseOrder.todayTotalOrderCountPercentage
                        : 0
                      ) | numberDecimal
                    }}% /
                    {{
                      (fcpo.percentBasedAutoOrderingAllocation ? fcpo.percentBasedAutoOrderingAllocation : 0)
                        | numberDecimal
                    }}%
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </ng-container>
    </main>
  </sa-lmo-frac-home-card>
</div>

<ng-template #noPOs>
  <main>
    No purchase orders available
  </main>
</ng-template>
